<template>
  <div
    class="col-text"
    :style="styleProperty"
    :class="{ 'have-badge': checkBadge }"
  >
    {{ columnProperties.value }}
  </div>
</template>

<script>
  import { textColumn } from '@/configs/dynamic-config/dynamic-column';
  import { computed } from '@vue/composition-api';
  export default {
    props: {
      columnProperties: Object,
    },
    setup(props) {
      const styleProperty = computed(() => {
        return {
          color:
            props.columnProperties.field.column_property.color_font ||
            textColumn.color_font,
          backgroundColor:
            props.columnProperties.field.column_property.color_badge ||
            textColumn.color_badge,
          fontSize:
            props.columnProperties.field.column_property.font_size ||
            textColumn.font_size,
        };
      });

      const checkBadge = computed(() => {
        return props.columnProperties.field.column_property.color_badge
          ? true
          : false;
      });

      return {
        styleProperty,
        checkBadge,
      };
    },
  };
</script>

<style scoped>
  .col-text {
    color: #737373;
    display: inline-block;
    white-space: nowrap;
  }

  .have-badge {
    padding: 0.3rem 0.5rem;
    border-radius: 10rem;
    text-align: center;
    text-transform: capitalize;
    font-size: 85%;
    font-weight: 600;
    line-height: 1;
    white-space: nowrap;
    vertical-align: baseline;
    transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out,
      border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out,
      background 0s, border 0s;
  }
</style>
